<!--  -->
<template>
  <div>
    <div v-for="item,index in arr" :key="index">
      <el-input v-model="item.oppid" style="width:300px;margin-bottom:10px" placeholder="请输入openid" />
    </div>
    <div>
      <el-button type="primary" @click="sumbitoppid">确定</el-button>
    </div>
  </div>
</template>

<script>
import { timingoppid } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      arr: [
        {
          oppid: ''
        },
        {
          oppid: ''
        }
      ],
      id: null,
      arrquery: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      console.log('item', item)
      this.id = item.id
      if (item.fix_open_ids_arr.length === 0) {
        console.log('新增')
      } else {
        const arrs = []
        item.fix_open_ids_arr.forEach((item, index) => {
          arrs.push({
            oppid: item
          })
        })
        this.arr = []
        this.arr = arrs
        console.log('编辑')
      }
    },
    async sumbitoppid() {
      this.arrquery = []
      this.arrquery = this.arr.map(item => { // item是数组中的每一个值
        return item.oppid
      })
      // eslint-disable-next-line eqeqeq
      if (this.arrquery[0] == '' && this.arrquery[1] == '') {
        this.arrquery = []
      }
      const data = await timingoppid({
        id: this.id,
        open_ids: this.arrquery
      })
      console.log('data', data)
      this.$message({
        type: 'success',
        message: '操作成功!'
      })
      this.$emit('updata')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
